/* eslint-disable prefer-destructuring */
import { v4 } from 'uuid';

import { blueprintData6, blueprintData7 } from '../../defaults';
import { connectIslands } from '../../../helpers';
import { decodeIslandSku } from '../../functions';
import { Island, Islands, IslandType, Kitchen, Panel } from '../../../blueprint-classes';
import { PADDING_BY_MATERIAL, STANDARD_ISLAND_PADDING } from '../../../blueprint-classes/surround-material/constants';
import { SurroundMaterialData } from '../../../blueprint-classes/surround-material/types';
import { updatePanels } from './update-panels';

export const updateIslands = (state: typeof blueprintData6['state'][0], surround: SurroundMaterialData): typeof blueprintData7['kitchens'][0]['design']['islands'] => {
	const kitchen = new Kitchen({
		dataIn: {
			material: {
				surround
			}
		}
	});
	const tIslands: Islands = kitchen.design.islands;
	const islandChildren = state.islands.map((island, iIsland) => {
		const decodedSku = decodeIslandSku(island.sku);

		// const tIsland = tIslands.newIsland(
		// 	decodedSku.islandType,
		// 	{
		// 		height: island.size.y,
		// 		width: island.size.x,
		// 		depth: island.size.z
		// 	}
		// );
		const tIsland = new Island({
			dataIn: {
				type: decodedSku.islandType,
				size: {
					height: island.size.y,
					width: island.size.x,
					depth: island.size.z
				},
				origin: island.centerpoint,
				axis: island.transform,
				surround
			},
			parent: kitchen.design.islands
		});
		const tIslandData = tIsland.serialize();
		kitchen.design.islands.children.push(tIsland);
		const updatedPanels = updatePanels(island, tIslandData, state);
		// tIslands.push(tIsland);

		return {
			...tIslandData,
			id: island.key,
			sku: island.sku,
			type: decodedSku.islandType,
			position: {
				// ...tIslandData.position,
				origin: island.centerpoint,
				axis: island.transform
			},
			surround: {
				...tIslandData.surround,
				override: false
			},
			// connections: island.connections.map((connection) => {
			// 	return {
			// 		// isSource: false, (if required, need to figure out how to calculate)
			// 		verticalAlign: connection.vAlignment,
			// 		horizontalAlign: connection.hAlignment,
			// 		alignToPanel: false,
			// 		padding: connection.padding,
			// 		offset: 0,
			// 		sourcePanelId: connection.sourcePanel,
			// 		targetIslandId: connection.targetIsland
			// 	}
			// }),
			// trims: island.panels.map((panel, iPanelTrim) => {
			// 	if (iPanelTrim === island.panels.length - 1) return null;
			// 	return {
			// 		id: v4(),
			// 		trimType: decodedSku.islandType === IslandType.Corner && (iPanelTrim === 0 || iPanelTrim === 4)
			// 			? 'fortyfive'
			// 			: 'ninty',
			// 		panels: [panel.key, island.panels[iPanelTrim + 1].key]
			// 	};
			// }).filter((trim) => trim !== null),
			panels: updatedPanels
		}
	});

	tIslands.children.forEach((tIsland, iIsland) => {
		if (iIsland > 0) {
			const prevIsland = tIslands.children[iIsland - 1];

			let sourcePanel: Panel | null = null;
			if (prevIsland.type === IslandType.Corner && tIsland.type === IslandType.Corner) {
				sourcePanel = prevIsland.panels.children[4];
			} else if (prevIsland.axis.y !== 0 && tIsland.axis.y === 0) {
				sourcePanel = prevIsland.panels.children[0];
			} else {
				sourcePanel = prevIsland.panels.children[3];
			}

			let targetPanel: Panel | null = null;
			if (tIsland.type === IslandType.Corner) {
				targetPanel = tIsland.panels.children[1];
			} else if (prevIsland.axis.y === 0 && tIsland.axis.y !== 0) {
				targetPanel = tIsland.panels.children[0];
			} else {
				targetPanel = tIsland.panels.children[1];
			}

			connectIslands({
				sourcePanel,
				targetPanel,
				offset: 0,
				padding: PADDING_BY_MATERIAL[surround.type] ?? STANDARD_ISLAND_PADDING
			})
		}
	});

	console.log('updateIslands:kitchen', state.defaultIsland, islandChildren);
	return {
		defaultIslandId: state.defaultIsland,
		children: islandChildren
	}
};
